import React, { useState, useEffect, useRef } from 'react';
import getSearchTickets from '../../../../api/graphql/queries/searchTickets';
import getSearchEvents from '../../../../api/graphql/queries/searchEvents';


const Tickets = ({
  handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'CarouselTickets',
    data: [],
    eventSlugnames: [],
    category: 'black',
  };
  // TODO: NEED TO ADD EVENT SELECTION

  const AmountWithCurrency = ({ number = 0, curr = 'EUR' }) => {
    const locales = (currency) => {
      let val = 'de-DE';
      switch (currency.toUpperCase()) {
        case 'EUR':
          val = 'de-DE';
          break;
        case 'USD':
          val = 'en-US';
          break;
        case 'GBP':
          val = 'en-US';
          break;

        default:
          break;
      }
      return val;
    };

    const amount = new Intl.NumberFormat(locales(curr), { style: 'currency', currency: curr ? curr.toUpperCase() : 'EUR' }).format(number);
    return <p className="text-base font-americaBlack text-black leading-snug my-0">{amount}</p>;
  };

  const eventInputRef = useRef(null);
  const [selectTicketsBy, setSelectTicketsBy] = useState();
  const [events, setEvents] = useState([]);
  const [clickedEvents, setClickedEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState();
  const [index, setIndex] = useState();
  const [tickets, setTickets] = useState([]);
  const [state, setState] = useState(initialState);
  const [selectedTickets, setSelectedTickets] = useState([]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    if (component) {
      setState(component);
      setSelectedTickets(component.data || []);
      setClickedEvents(component.eventSlugnames || []);
      if (((component.data && component.data.length) && (component.eventSlugnames && component.eventSlugnames.length)) || false) {
        console.log('this carousel contains both tickets and events, please review');
      }
      if (component.data && component.data.length) { setSelectTicketsBy('ticket'); }
      if (component.eventSlugnames && component.eventSlugnames.length) { setSelectTicketsBy('event'); }
    } else {
      const componentObj = {
        id,
        component: state,
      };

      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  const selectTicketHandler = (selectedTicket) => {
    const componentObj = {
      id,
      component: state,
    };

    let newState = {};

    const ticketIndex = selectedTickets.findIndex(ticket => ticket.ticketSlugName === selectedTicket.ticketSlugName);

    if (ticketIndex === -1) {
      newState = {
        ...state,
        data: [...state.data, selectedTicket],
      };
      setSelectedTickets([...selectedTickets, selectedTicket]);
      setState(newState);
    } else {
      const newTickets = selectedTickets;
      newTickets.splice(ticketIndex, 1);
      newState = {
        ...state,
        data: [...newTickets],
      };
      setSelectedTickets([...newTickets]);
      setState(newState);
    }
    componentObj.component = newState;
    // setClickedEvents([]);
    // componentObj.component.eventSlugnames = [];
    // const stateAdj = { ...state };
    // stateAdj.eventSlugnames = [];
    // setState(stateAdj);

    handlerSetComponents(componentObj, index);
  };

  const searchTicketsHandler = (e) => {
    const { value } = e.target;
    if (value === '') return setTickets([]);
    getSearchTickets(value, selectedEvent)
      .then((res) => {
        if (res === null) return setTickets([]);
        setTickets(res);
      })
      .catch(err => console.log(err));
  };

  // logic to handle event selection (without selecting individual tickets)

  const chooseEvent = (slug) => {
    const eventIndex = clickedEvents.findIndex(e => e === slug);

    let clickedEventsAdj = [];
    let newState = {};

    if (eventIndex === -1) {
      clickedEventsAdj = [...clickedEvents, slug];
      newState = {
        ...state,
        eventSlugnames: [...clickedEventsAdj],
      };
    } else {
      const newEvents = [...clickedEvents];
      newEvents.splice(eventIndex, 1);
      clickedEventsAdj = newEvents;
      newState = {
        ...state,
        eventSlugnames: [...clickedEventsAdj],
      };
    }
    setClickedEvents(clickedEventsAdj);
    setState(newState);

    const componentObj = {
      id,
      component: state,
    };

    // setSelectedTickets([]);
    // const stateAdj = { ...state };
    // stateAdj.data = [];
    // setState(stateAdj);

    if (clickedEventsAdj.length > 1) {
      componentObj.component.isGrid = true;
      componentObj.component.isConcert = true;
    } else {
      componentObj.component.isGrid = false;
      componentObj.component.isConcert = false;
    }
    componentObj.component.eventSlugnames = clickedEventsAdj;

    handlerSetComponents(componentObj, index);
  };

  const selectEventHandler = (slug) => {
    if (selectTicketsBy === 'event') {
      chooseEvent(slug);
    } else if (selectTicketsBy === 'ticket') {
      setSelectedEvent(slug);
      setEvents([]);
      eventInputRef.current.value = '';
      getSearchTickets('', slug)
        .then((res) => {
          if (res === null) return setTickets([]);
          setTickets(res);
        })
        .catch(err => console.log(err));
    } else {
      console.log('no selectticketsby was selected');
    }
  };

  // useEffect(() => {
  //   console.log('clickedEvents', clickedEvents);
  // }, [clickedEvents]);

  const searchEventHandler = (e) => {
    const { value } = e.target;
    if (value === '') return setEvents([]);
    getSearchEvents(value).then((res) => {
      if (res === null) return setEvents([]);
      setEvents(res);
    });
  };

  const inputHandler = (e) => {
    const { value, name } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: value.toLowerCase(),
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const switchSelectedTicketsMethod = (method) => {
    // reseting current method information in order to start form a clean slate
    setClickedEvents([]);
    setSelectedTickets([]);
    setSelectedEvent();
    setTickets([]);
    setEvents([]);

    const stateAdj = { ...state };
    stateAdj.data = [];
    stateAdj.eventSlugnames = [];
    setState(stateAdj);

    const componentObj = {
      id,
      component: state,
    };

    componentObj.component.eventSlugnames = [];
    componentObj.component.data = [];

    handlerSetComponents(componentObj, index);

    // Setting selection methods
    setSelectTicketsBy(method);
  };

  return (
    <>
      <div className={`flex flex-row px-8 ml-6.5 items-center bg-greyFilter ${!selectTicketsBy ? 'rounded-r-lg py-8px' : 'rounded-tr-lg pt-8px pb-0'}`}>
        <span className="text-black font-americaMonoBold uppercase text-xs">select tickets by:</span>
        <div className="flex ml-2 mr-4">
          <button onClick={() => switchSelectedTicketsMethod('event')} type="button" className={`font-americaMonoBold text-xs px-6.5 py-2 rounded-full uppercase ${selectTicketsBy === 'event' ? 'bg-black text-white' : 'bg-greyFilterItems text-black'} `}>Event</button>
          <button onClick={() => switchSelectedTicketsMethod('ticket')} type="button" className={`ml-4 font-americaMonoBold text-xs px-6 py-2 rounded-full uppercase ${selectTicketsBy === 'ticket' ? 'bg-black text-white' : 'bg-greyFilterItems text-black'}`}>Ticket</button>
        </div>
        {selectTicketsBy && <div className="font-americaMonoBold text-xs py-2 rounded-full uppercase text-black">{`selecting by ${selectTicketsBy}`}</div>}
      </div>
      {selectTicketsBy && (
        <div className="flex flex-col">
          <div className={`flex justify-end flex-row ${selectedEvent && 'min-h-143px'} ${events.length > 0 && 'h-190px'} ${tickets.length > 0 && 'min-h-190px'}`}>
            <div className={`bg-greyFilter rounded-l-lg w-full flex flex-col ${selectedEvent ? 'h-18' : 'h-16'} ${events.length > 0 && 'relative'} ${selectedEvent && 'relative'}`}>
              <p className="text-xs uppercase pl-1 text-black font-americaMonoRegular mb-0 pl-15 mt-1">Search Event</p>
              <input className="rounded-full pr-2 pl-8 py-2 mr-2 outline-none ml-14" ref={eventInputRef} type="text" onChange={searchEventHandler} />
              <span className="font-icon icon-search z-5 text-black absolute mt-8 ml-18 text-sm" />
              {selectedEvent && (
                <div className="ml-12 mr-2">
                  <p className="font-americaMonoBold text-xs uppercase pb-6px bg-greyFilter rounded-t-lg pl-6 mt-2 mb-0 mx-0 pt-1 mt-2">Selected event</p>
                  <div className="overflow-auto bg-greyFilterItems rounded-b-lg max-h-24 w-full pb-1 max-h-75 mr-2 mb-6px">
                    <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mb-0 mt-0">{selectedEvent}</p>
                  </div>
                </div>
              )}
              {events.length > 0 && (
                <div className={`z-top ml-12 mr-2 absolute mt-18 mr-2 min-w-89% ${selectedEvent && 'mt-14 min-w-92'}`}>
                  <p className={`font-americaMonoBold text-xs uppercase bg-greyFilter pl-6 mt-1 mb-0 mr-2 pb-1 pt-1 w-full py-2 rounded-t-lg ${selectedEvent ? 'py-2' : 'pb-1'}`}>Available events</p>
                  <div className="first-child overflow-auto bg-greyFilterItems rounded-b-lg pb-2 mr-4 max-h-75 w-full">
                    {events.map(event => (
                      <div onClick={() => selectEventHandler(event.eventSlugName)} key={event.eventSlugName}>
                        <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mt-1">{event.eventSlugName}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-start rounded-tr-lg flex-col w-full">
              <div className={`bg-greyFilter w-full flex flex-col ${selectedEvent ? 'h-18' : 'h-16'}`}>
                <p className="text-xs uppercase pl-1 text-black font-americaMonoRegular mb-0 mt-1">Search ticket</p>
                <input className={`rounded-full pr-4 pl-8 py-2 mr-5 outline-none  ${!selectedEvent && 'pointer-events-none bg-greyFilterItems'}`} type="text" onChange={searchTicketsHandler} />
                {selectedEvent && <span className="font-icon icon-search z-5 text-black absolute mt-7 ml-3 text-sm" />}
              </div>
              <div>
                {tickets.length > 0 && (
                  <div className="overflow-auto rounded-b-lg max-h-150 w-full flex flex-col">
                    <p className="font-americaMonoBold text-xs uppercase py-6px bg-greyFilter rounded-t-lg pl-5 mb-0 mr-2 mt-1">Available tickets</p>
                    <div className="first-child overflow-auto bg-greyFilterItems rounded-b-lg pb-1 max-h-75 mr-2 mb-6px">
                      {tickets.map(ticket => (
                        <div onClick={() => selectTicketHandler(ticket)} key={ticket.ticketSlugName}>
                          <p className="text-black cursor font-americaMonoRegular outline-none pl-6 mb-0 mt-0">{ticket && ticket.hasOwnProperty('ticketReadableName') && ticket.ticketReadableName !== null && ticket.ticketReadableName.en}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {clickedEvents.length > 0 && (
                <div className=" ml-0 min-w-92 mr-8px pb-2">
                  <p className="font-americaMonoBold text-xs uppercase bg-greyFilter pl-6 mt-3 mb-0 mr-2 pb-1 pt-1 w-full py-2 rounded-t-lg py-2">Chosen Events</p>
                  <div className="first-child overflow-auto bg-greyFilterItems rounded-b-lg pb-2 mr-4 max-h-75 w-full">
                    {clickedEvents.map(event => (
                      <div key={event}>
                        <p className="text-black cursor font-americaMonoRegular outline-none w-full pl-6 mt-1">
                          {event}
                          <span onClick={() => chooseEvent(event)} className="font-icon icon-close-btn1 pl-1 text-xs text-black" />
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                )}
              </div>
            </div>
          </div>
          <div>
            {selectedTickets.length > 0 && (
              <div className="ml-12 mr-2 mb-2 mt-2">
                <p className="font-americaMonoBold text-xs uppercase pb-1 bg-greyFilter rounded-t-lg pl-6 mb-0 mx-0 pt-1 mt-0">Selected Tickets</p>
                <div className="overflow-auto bg-greyFilterItems rounded-b-lg py-1 w-full flex flex-row flex-wrap pl-1 pb-3">
                  {selectedTickets.map(ticket => (
                    <div className="bg-greyFilter text-base font-americaBlack text-black rounded m-8px pb-5 w-210px h-275px flex flex-col pt-4 px-5 relative justify-between" key={ticket.ticketSlugName}>
                      <div>
                        <p className="text-base font-americaBlack text-black leading-snug mb-1">
                          {ticket && ticket.hasOwnProperty('ticketReadableName') && ticket.ticketReadableName !== null && ticket.ticketReadableName.en}
                          {' '}
                          <span onClick={() => selectTicketHandler(ticket)} className="font-icon icon-close-btn1 absolute text-black text-16 font-thin right-0 absolute pr-5px pt-px top-0" />
                        </p>
                        {ticket.description.en && <p className="text-12 mt-0">{ticket.description.en}</p>}
                      </div>
                      <div className="w-full border-t pt-1 border-black ">
                        <AmountWithCurrency curr={ticket.currency} number={ticket.amount} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="w-full bg-greyFilter px-5 rounded-b-lg justify-around items-center flex flex-row">
              <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8px w-full ml-10" htmlFor="category">
                Select Category
                <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 p-2 text-sm" onChange={inputHandler} name="category" type="text" value={state.category} readOnly={reusableComponent && reusableComponent} />
              </label>
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default Tickets;
